import DateUtils from '@/utils/DateUtils';
import { ESocialRewards } from '@/views/SocialRewards/SocialRewardsEnum';

export const features = [
  {
    value: 'rewardProgram',
    title: 'Loyalty Rewards Program',
    icon: 'reward-ratio',
    getDescription: ({ coinRewardPercentage, refundsLimitDays }: any) =>
      `Members will get ${Number(coinRewardPercentage).toFixed(
        0
      )}% back in Coins for every purchase${
        refundsLimitDays > 0
          ? ` with ${refundsLimitDays} days of refund policy`
          : ''
      }`
  },
  {
    value: 'welcomeCoins',
    title: 'Welcome Coins',
    icon: 'welcome-coins',
    getDescription: ({ coinsReward }: any) =>
      `${Number(coinsReward)} Coins per member`
  },
  {
    value: 'sellCoins',
    title: 'Sell Coins',
    icon: 'sell-coins',
    getDescription: ({ name, incentive, endDate }: any) => {
      return `You're selling branded Coins through the Twism app${
        incentive > 0
          ? `<br/>${name} active offering ${incentive}% of bonus${
              endDate
                ? `, expiring on ${DateUtils.formattedDate({
                    date: endDate
                  })}`
                : ''
            }`
          : ''
      }`;
    }
  },
  {
    value: 'referralProgram',
    title: 'Referral Program',
    icon: 'referral',
    getDescription: ({ referringDiscount, referredDiscount }: any) =>
      `${
        Number(referringDiscount) > 0
          ? `Referring will earn ${Number(referringDiscount)} Coins<br/>`
          : ''
      }
        ${
          Number(referredDiscount) > 0
            ? `Referred will earn ${Number(referredDiscount)}% off Coin`
            : ''
        }`
  },
  {
    value: 'socialRewards',
    title: 'Social Rewards',
    icon: 'social-rewards',

    getDescription: (socialRewards: any) => {
      const socialRewardArrText: any = [];
      const socialRewardsText: any = {
        [ESocialRewards.FACEBOOK_SHARE]: `Share on Facebook`,
        [ESocialRewards.FACEBOOK_LIKE]: `Like on Facebook`,
        [ESocialRewards.TWITTER_FOLLOW]: `Follow on Twitter`,
        [ESocialRewards.TWITTER_SHARE]: `Share on Twitter`,
        [ESocialRewards.TIKTOK_FOLLOW]: `Follow on TikTok`,
        [ESocialRewards.INSTAGRAM_FOLLOW]: `Follow on Instagram`,
        [ESocialRewards.YOUTUBE_SUBSCRIBE]: `Subscribe on Youtube`,
        [ESocialRewards.PINTEREST_FOLLOW]: `Follow on Pinterest`
      };

      socialRewards.forEach(
        (item: any) =>
          socialRewardsText[item.type] &&
          socialRewardArrText.push(
            `${socialRewardsText[item.type]}: ${item.coins} Coins`
          )
      );

      return socialRewardArrText.join('<br/>');
    }
  },
  {
    value: 'inviteCustomers',
    title: 'Invite Customers',
    icon: 'invite-customers',
    getDescription: ({ coinsReward }: any) =>
      `${Number(coinsReward)} Coins per customer`
  },
  {
    value: 'emailAutomation',
    title: 'Email automation',
    icon: 'email-automation',
    getDescription: () => `Reward & invite non-members customers after purchase`
  }
];
